import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { IUser } from '@shared/models/user';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { selectAuthUser } from '@state/auth/auth.selectors';
import { setAuthModal } from '@state/auth/auth.actions';

@UntilDestroy()
@Component({
  selector: 'app-menu-mobile',
  templateUrl: './menu-mobile.component.html',
  styleUrls: ['./menu-mobile.component.scss'],
})
export class MenuMobileComponent implements OnInit {
  @Input() open = false;
  @Output() closeMenu = new EventEmitter<void>();

  protected user?: IUser;
  protected year = new Date().getFullYear();

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store
      .select(selectAuthUser)
      .pipe(untilDestroyed(this))
      .subscribe((user) => (this.user = user));
  }

  closeMenuHandler(): void {
    this.closeMenu.emit();
  }

  showSignInModal(): void {
    this.closeMenuHandler();
    this.store.dispatch(setAuthModal({ authModal: 'signin' }));
  }
}
